<script>
export default {
  name: "DeviceStatusIcon",
  props: {
    device: {
      type: Object,
      required: true
    },
    showDescription: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    status() {
      if (this.device.status === "preregistration") {
        return "P"
      } else if (!this.device.suspended && this.device.enabled) {
        return "A"
      } else if (this.device.suspended && this.device.enabled) {
        return "O"
      } else if (!this.device.enabled) {
        return "S"
      } else {
        return ""
      }
    },
    description() {
      if (this.device.status === "preregistration") {
        return this.$t("PREDREGISTRACE_ZARIZENI")
      } else if (!this.device.suspended && this.device.enabled) {
        return this.$t("activeZarizeniCerpaSluzbu")
      } else if (this.device.suspended && this.device.enabled) {
        return this.$t("overLimitZarizeniPrekrociloLimit")
      } else if (!this.device.enabled) {
        return this.$t("standByZarizeniJeNeaktivni")
      } else {
        return ""
      }
    },
    style() {
      if (this.device.status === "preregistration") {
        return "atom-circle--warning"
      } else if (!this.device.suspended && this.device.enabled) {
        return "atom-circle--success"
      } else if (this.device.suspended && this.device.enabled) {
        return "atom-circle--danger"
      } else if (!this.device.enabled) {
        return "atom-circle--gray"
      } else {
        return ""
      }
    },
    textStyle() {
      if (this.device.status === "preregistration") {
        return "text-warning"
      } else if (!this.device.suspended && this.device.enabled) {
        return "text-success"
      } else if (this.device.suspended && this.device.enabled) {
        return "text-danger"
      } else if (!this.device.enabled) {
        return "text-gray"
      } else {
        return ""
      }
    }
  }
}
</script>

<template>
  <div class="d-flex align-items-center">
    <div v-tooltip :class="['atom-circle', style]" :title="showDescription ? '' : description">
      {{ status }}
    </div>
    <div v-if="showDescription" :class="textStyle" class="ml-2">
      {{ description }}
    </div>
  </div>
</template>
